export enum IconPositionTypes {
    before = 'before',
    after = 'after',
}
export type ButtonPropIconPosition = keyof typeof IconPositionTypes;

export enum AsTypes {
    button = 'button',
    a = 'a',
}
export type ButtonPropAs = keyof typeof AsTypes;

export enum SizeTypes {
    sm = 'sm',
    md = 'md',
    lg = 'lg',
}
export type ButtonPropSize = keyof typeof SizeTypes;
